/** @fileoverview list_query_groups の共通定数 */

/** ツール名（単一参照点） */
export const LIST_QUERY_GROUPS_NAME = "list_query_groups" as const;

/** LLM へ提示する説明文 */
export const LIST_QUERY_GROUPS_DESC = `Lists Query Groups for a Search Analytics project.

Use this when a user asks to list, search, or summarize Query Groups for a given project.

Input:
- 'projectId' (required): The ID of the target project.

Notes:
- Search Analytics only. Query Groups do not exist for User Analytics projects.
- Read-only. Does not create, update, or delete anything.
- Returns: { projectType: "SearchAnalyticsProject", searchAnalyticsId, queryGroups: [{ id, name, description, op, patterns: [{ type, pattern }] }] }.`;
